// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import {get} from 'mattermost-redux/selectors/entities/preferences';
import {showFlaggedPosts, showPinnedPosts} from 'actions/views/rhs';
import {Preferences} from 'utils/constants';

import PostPreHeader from './post_pre_header';

function makeMapStateToProps(state) {
    return {
        center:
            get(
                state,
                Preferences.CATEGORY_DISPLAY_SETTINGS,
                Preferences.CHANNEL_DISPLAY_MODE,
                Preferences.CHANNEL_DISPLAY_MODE_DEFAULT,
            ) === Preferences.CHANNEL_DISPLAY_MODE_CENTERED,
        compactDisplay:
            get(
                state,
                Preferences.CATEGORY_DISPLAY_SETTINGS,
                Preferences.MESSAGE_DISPLAY,
                Preferences.MESSAGE_DISPLAY_DEFAULT,
            ) === Preferences.MESSAGE_DISPLAY_COMPACT,
    };
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({
        showFlaggedPosts,
        showPinnedPosts,
    }, dispatch),
});

export default connect(makeMapStateToProps, mapDispatchToProps)(PostPreHeader);
